export default "__VITE_ASSET__Dd9akX$o__"